import { combineReducers } from "redux";
import register from "./Register/reducers";
import contact from "./Contact/reducers";

const rootReducer = combineReducers({
    register, contact
});

export default rootReducer;
